import { render, staticRenderFns } from "./Field-Set-Text.vue?vue&type=template&id=a8151a94&"
import script from "./Field-Set-Text.vue?vue&type=script&lang=js&"
export * from "./Field-Set-Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports